<template>
	<div>
		<div class="background1">
			<div class="table" style="padding: 0">
				<div class="stateDiagram">
					<div class="sype_title">{{$t('label_625')}}</div>
					<div style="display: flex">
						<div style="display: flex;align-items: center">
							<div style="width: 20px;height: 20px;background: #0353C1;margin-right: 5px"></div>
							<div style="margin-right: 10px">{{$t('label_191')}}</div>
						</div>
						<div style="display: flex;align-items: center">
							<div style="width: 20px;height: 20px;background: red;margin-right: 5px"></div>
							<div style="margin-right: 10px">{{$t('label_152')}}</div>
						</div>
						<div class="month_box" style="margin-right:0px;">
							<el-date-picker v-model="date" align="right" type="month" :clearable="false" format="yyyy-MM" value-format="yyyy-MM"
                              :placeholder="$t('选择日期')" @change="changeDate" :picker-options="{disabledDate(time) {return time.getTime() > Date.now();}}">
							</el-date-picker>
							<i class="el-icon-arrow-left left" @click="changeMonth(-1)"></i>
							<i class="el-icon-arrow-right right" @click="changeMonth(1)"></i>
						</div>
					</div>
				</div>
				<div style="width:98%;display: flex;align-items: center;justify-content: space-around">
					<!--统计图-->
					<div class="echart_style">
						<div id="main" style="width:930px;height: 230px;"></div>
					</div>
					<!--各种率-->
					<div class="box_rigth_lll" style="width: 210px">
						<div class="number_rigth">{{(activation>100?100:activation)}}<span>%</span>{{$t('label_191')}}  </div>
						<div style="margin-bottom:15px;"></div>
						<el-progress color="#3fb393" :show-text="false" :stroke-width="8" :percentage="parseFloat(activation)" v-if="!isNaN(parseFloat(activation))"></el-progress>
						<div class="number_rigth" style="margin-top:12px;">
              {{
                activation >= maxActivation ?
                  (activation >= 100?100:activation) :
                  (maxActivation >= 100?100:maxActivation)

              }}
              <span>%</span>{{$t('label_191')}}{{$t('label_659')}}
            </div>
						<div style="margin-bottom:15px;"></div>
						<el-progress color="#3fb393" :show-text="false" :stroke-width="8" :percentage="maxActivation"></el-progress>
						<div class="number_rigth" style="margin-top:12px;">
              {{
                activation <= minActivation ?
                  (activation >= 100?100:activation) :
                  (minActivation >= 100?100:minActivation)
              }}
              <span>%</span>{{$t('label_191')}}{{$t('label_661')}}
            </div>
						<div style="margin-bottom:15px;"></div>
						<el-progress color="#3fb393" :show-text="false" :stroke-width="8" :percentage="minActivation"></el-progress>
					</div>
				</div>
				<div class="center_box" style="display: flex;  justify-content: space-between; margin-top: 20px;">
					<div class="txt_box">{{$t('label_663')}}</div>
					<div class="buttonBox" style="margin-top: 15px; margin-right: 25px;">
<!--						<div class="chooseButton searchButton" @click="exportClick" style="margin-top: -20px;"><i class="el-icon-upload2"></i>{{$t('btn_10')}}</div>-->
					</div>
				</div>
				<div class="tableMin" style="margin-top:10px">
					<el-table :empty-text="$t('label_357')" ref="singleTable" :data="tableData" highlight-current-row @current-change="handleCurrentChangeTree"
					 style="width: 98%;margin: 5px;overflow: auto;
            border-left: 1px solid #ebeef5;border-right: 1px solid #ebeef5;"
					 max-height="calc(100vh - 590px)" :header-cell-style="{'background-color': '#45494f','color': '#ffffff',}">
						<el-table-column header-align="center" align="center" :label="$t('label_369') + '.'" type="index" :index="getIndex" width="100">
						</el-table-column>
						<el-table-column prop="date" :label="$t('label_70')" align="center">
						</el-table-column>
						<el-table-column prop="activation" :label="$t('label_191') + '(%)'" align="center">
							<template slot-scope="scope">
									{{(scope.row.activation>100?100:scope.row.activation)}}
							</template>
						</el-table-column>
						<el-table-column prop="workTime" :label="$t('label_665') + '(' + $t('label_647') + ')'" align="center">
						</el-table-column>
						<el-table-column prop="loadTime" :label="$t('label_609') + '(' + $t('label_647') + ')'" align="center">
						</el-table-column>
						<el-table-column prop="shutdownTime" :label="$t('label_667') + '(' + $t('label_647') + ')'" align="center">
						</el-table-column>
					</el-table>
				</div>
				<exportMes :exportTitle="exportTitle" :exportData="tableData" :exportList="exportList" style="width: 100%;height: 100%"
				 ref="exportBox"></exportMes>
			</div>
		</div>
	</div>

</template>

<script>
	import * as echarts from 'echarts';
	import utils from '@/utils/utils'
	import popMesBox from "@/components/list/popover/pop";
	import Page from "@/components/common/page";
	import equipmentMonitoringService from "@/assets/js/signal/equipmentMonitoringService.js";
	import exportMes from "@/components/list/export/export";

	export default {
		name: "monthlyReport",
		components: {
			Page,
			popMesBox,
			exportMes
		},
		props: {
			eqDetailInfo: {
				type: Object,
				default: {}
			},
			workTime: {
				type: Object,
				default: {}
			},
		},
		data() {
			return {
				pageNum: 1,
				pageSize: 10,
				pageCount: 0,
				tableData: [],
				exportTitle: this.$t('label_663'),
				exportList: [{
					column: 'date',
					title: this.$t('label_70'),
					headerAlign: 'center',
					align: 'center',
					width: '200px'
				}, {
					column: 'activation',
					title: this.$t('label_191') + '(' + this.$t('%') + ')',
					headerAlign: 'center',
					align: 'center',
					width: '200px'
				}, {
					column: 'workTime',
					title: this.$t('label_665') + '(' + this.$t('label_647') + ')',
					headerAlign: 'center',
					align: 'center',
					width: '200px'
				}, {
					column: 'loadTime',
					title: this.$t('label_609') + '(' + this.$t('label_647') + ')',
					headerAlign: 'center',
					align: 'center',
					width: '200px'
				}, {
					column: 'shutdownTime',
					title: this.$t('label_667') + '(' + this.$t('label_647') + ')',
					headerAlign: 'center',
					align: 'center',
					width: '200px'
				}],
				date: '',
				beginTime: '',
				endTime: '',
				activation: 0,
				maxActivation: 0,
				minActivation: 0,
				monthDay: [0, 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
			}
		},
		methods: {
			getIndex(index) {
				return (this.pageNum - 1) * this.pageSize + index + 1
			},
			exportClick() {
				this.$refs.exportBox.setExportExcel();
			},
			handleCurrentChangeTree(info) {
				this.tableDataTreeInfo = info;
			},

			myEcharts(date, barData, lineData) {
				for(let i=0;i<lineData.length;i++){
					if(lineData[i]>100){
						lineData[i]=100
					}
				}
				let date_ = [];
				for (let d of date) {
					date_.push(d.substring(8));
				}
				let chartDom = document.getElementById('main');
				let myChart = echarts.init(chartDom);
				let option = {
					grid: { //改位置以及宽高
						top: '20%',
						left: '6%',
						right: '6%',
						bottom: '10%'
					},
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'cross',
							crossStyle: {
								color: '#999'
							}
						}
					},
					xAxis: [{
						type: 'category',
						data: date_,
						axisPointer: {
							type: 'shadow'
						},
						axisTick: { //去掉x轴刻度
							show: false,
						},
					}],
					yAxis: [{
							type: 'value',
							name: '(%)',
							min: 0,
							max: 100,
							interval: 20,
							axisLabel: {
								formatter: '{value}'
							},
							axisLine: { //去掉y轴线
								show: false
							},
							axisTick: { //去掉y轴刻度
								show: false,
							},
						},
						{
							type: 'value',
							name: '(' + this.$t('label_207') + ')',
							min: 0,
							minInterval: 1,
							axisLabel: {
								formatter: '{value}'
							},
							axisLine: { //去掉y轴线
								show: false
							},
							axisTick: { //去掉y轴刻度
								show: false,
							},
							splitLine: { //去掉y轴网格
								show: false,
							},
						}
					],
					series: [{
							name: this.$t('label_191'),
							type: 'line',
							symbol: 'none',
							color: '#0353C1',
							tooltip: {
								valueFormatter: function(value) {
									return (value>100?100:value) + ' %';
								}
							},
							data: lineData
						},
						{
							name: this.$t('label_152'),
							type: 'bar',
							color: '#ff0000',
							barMaxWidth: 40,
							yAxisIndex: 1,
							tooltip: {
								valueFormatter: (value) => {
									return value + ' ' + this.$t('label_207');
								}
							},
							data: barData
						}
					]
				}
				option && myChart.setOption(option);
			},

			selectTime() {
				let param = {
					beginTime: this.beginTime,
					endTime: this.endTime,
					id: this.eqDetailInfo.id,
					type: 1
				};
				equipmentMonitoringService.selectMonth(param).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.myEcharts(data.data.dateList, data.data.dataAbnormalStopList, data.data.activationList);
						this.activation = data.data.activation;
						this.maxActivation = data.data.maxActivation;
						this.minActivation = data.data.minActivation;
						let tableData_ = data.data.list;
						for (let index in tableData_) {
							tableData_[index].workTime = (tableData_[index].workTime / 1000 / 60).toFixed(0);
							tableData_[index].loadTime = (tableData_[index].loadTime / 1000 / 60).toFixed(0);
							tableData_[index].shutdownTime = ((tableData_[index].shutdownTime / 1000 + tableData_[index].undefinedTime / 1000) / 60).toFixed(0);
						}
						this.tableData = tableData_;
					};
				}).catch((response) => {
					console.log(response)
				})
			},
			changeMonth(i) {
				if (i > 0 && utils.getMonthFormatDate() == this.date) {
					return;
				}
				let y = Number(this.date.substring(0, 4));
				let m = Number(this.date.substring(5)) + i;
				if (m > 12) {
					y = y + Math.floor(m / 12);
					m = m % 12;
					if (m == 0) m = 1;
				} else if (m < 0) {
					y = y + Math.floor(m / 12);
					m = m % 12 + 12;
					if (m == 12) {
						y--;
					}
				} else if (m == 0) {
					y--
					m = 12;
				}
				this.date = y + "-" + this.zero(m);
				this.changeDate();
			},
			calcTime(time, i) {
				let d = new Date(time).getTime() + 1000 * 60 * 60 * 24 * i;
				let date = new Date(d);
				return date.getFullYear() + "-" + this.zero(date.getMonth() + 1) + "-" + this.zero(date.getDate()) +
					" " + this.zero(date.getHours()) + ":" + this.zero(date.getMinutes()) + ":" + this.zero(date.getSeconds());
			},
			calcDay(date, i) {
				let d = new Date(date).getTime() + 1000 * 60 * 60 * 24 * i;
				date = new Date(d);
				return date.getFullYear() + "-" + this.zero(date.getMonth() + 1) + "-" + this.zero(date.getDate());
			},
			zero(i) {
				return i > 9 ? i : '0' + i;
			},
			refresh() {
				this.selectTime();
			},
			getMaxDay(yyyyMM) {
				let m = Number(yyyyMM.substring(5));
				if (m == 2 && Number(yyyyMM.substring(0, 4)) % 4 == 0) {
					return yyyyMM + '-29';
				}
				return yyyyMM + '-' + this.monthDay[m];
			},
			changeDate() {
				//计算开始和结束时间
				if (this.workTime.beginTimeOverDay == 0) {
					this.beginTime = this.date + '-01' + this.workTime.beginTime.substring(10);
				} else {
					this.beginTime = this.calcDay(this.date + '-01', 1) + this.workTime.beginTime.substring(10);
				}
				if (this.workTime.endTimeOverDay == 0) {
					this.endTime = this.getMaxDay(this.date) + this.workTime.endTime.substring(10);
				} else {
					this.endTime = this.calcDay(this.getMaxDay(this.date), 1) + this.workTime.endTime.substring(10);
				}
				this.refresh();
			}
		},
		mounted() {
			this.changeDate();
		},
		created() {
			this.date = utils.getMonthFormatDate();
			this.beginTime = this.workTime.beginTime;
			this.endTime = this.workTime.endTime;

		}
	}
</script>

<style>
	.txt_box {
		font-size: 20px;
		font-weight: bold;
	}

	.month_box {
		position: relative;
	}

	.month_box .el-date-editor.el-input,
	.el-date-editor.el-input__inner {
		width: 160px;
	}

	.month_box .el-input--prefix .el-input__inner {
		padding-left: 62px;
	}

	.month_box .left {
		position: absolute;
		left: 30px;
		top: 12px;
		cursor: pointer;
	}

	.month_box .right {
		position: absolute;
		left: 130px;
		top: 12px;
		cursor: pointer;
	}

	.box_rigth_lll .el-progress-bar__outer {
		background-color: #d0d0d0;
	}

	.stateDiagram {
		width: 98%;
		display: flex;
		align-items: center;
		justify-content: space-between;
		/* margin-top: 20px; */
	}

	.sype_title {
		font-size: 0px;
		font-weight: bold;
	}

	.echart_styles {
		width: 95%;
		height: 230px;
	}

	.box_rigth_lll {
		width: 180px;
		height: 220px;
		background: #EFEFEF;
		border: 1px #CACACA solid;
		padding: 10px 20px 10px 20px;
		box-sizing: border-box;
	}

	.number_rigth {
		font-size: 16px;
		font-weight: bold;
	}
</style>



// WEBPACK FOOTER //
// src/components/list/equipmentDetails/monthlyReport.vue